import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-textarea-dialog',
  template: `

    <div class="modal-header d-flex flex-column align-items-start">
      <h4 class="modal-title">{{ title | async }}</h4>
      <p class="mb-0" *ngIf="description | async" [innerHTML]="description | async"></p>
    </div>
    <div class="modal-body">
      <textarea *ngIf="editable"
                autocomplete="off"
                [(ngModel)]="value"
                class="form-control form-control-sm"
                [rows]="20">
      </textarea>

      <textarea *ngIf="!editable"
                autocomplete="off"
                [readOnly]="true"
                [ngModel]="value"
                class="form-control form-control-sm"
                [rows]="20">
      </textarea>
    </div>
    <div class="modal-footer">

      <button type="button"
              *ngIf="editable"
              class="btn btn-primary btn-sm"
              (click)="activeModal.close(value)">
        {{ saveBtnLabel | async }}
      </button>

      <button type='button' class='btn btn-outline-secondary btn-sm'
              *ngIf="editable"
              (click)='activeModal.dismiss()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>

      <button type="button"
              *ngIf="!editable"
              class="btn btn-outline-secondary btn-sm"
              (click)="activeModal.dismiss()">
        {{ 'BUTTON.CLOSE' | translate }}
      </button>
    </div>
  `
})
export class TextareaDialogComponent {

  @Input() title: Observable<string>;
  @Input() value: string;
  @Input() editable: boolean;
  @Input() description?: Observable<string>;
  @Input() saveBtnLabel: Observable<string> = this.translateService.stream('BUTTON.CONFIRM')

  constructor(public activeModal: NgbActiveModal,
              private translateService: TranslateService) {
  }
}
